import stick1_left from './banner_left/stick1.png';
import flower1_left from './banner_left/flower1.png';
import lens1_left from './banner_left/lens1.png';
import lens1_grayzel_left from './banner_left/lens1_grayzel.png';
import lens1_blue_left from './banner_left/lens1_blue.png';
import stick2_left from './banner_left/stick2.png';
import flower2_left from './banner_left/flower2.png';
import hue1_left from './banner_left/hue1.png';
import hue2_left from './banner_left/hue2.png';
import girl_left from './banner_left/girl.png';
import girl_my_left from './banner_left/girl_my.png';
import flower3_big_left from './banner_left/flower3_big.png';
import lens2_big_left from './banner_left/lens2_big.png';
import lens2_big_grayzel_left from './banner_left/lens2_big_grayzel.png';
import stick4_left from './banner_left/stick4.png';
import flower4_left from './banner_left/flower4.png';
import lens3_left from './banner_left/lens3.png';
import lens3_grayzel_left from './banner_left/lens3_grayzel.png';
import lens3_blue_left from './banner_left/lens3_blue.png';
import stick5_left from './banner_left/stick5.png';
import flower5_left from './banner_left/flower5.png';

import balloon1_right from './banner_right/balloon1.png';
import balloon2_right from './banner_right/balloon2.png';
import balloon3_right from './banner_right/balloon3.png';
import balloon4_right from './banner_right/balloon4.png';
import lens1_right from './banner_right/lens1.png';
import lens2_right from './banner_right/lens2.png';
import only_girl_right from './banner_right/only_girl.png';
import thread_right from './banner_right/thread.png';

import buttonON from './sticker/Sticker_On.png';
import buttonOFF from './sticker/Sticker_Off.png';

import appsflyer_icon from './newUi/appsflyer.png';
import download_icon from './newUi/download.png';

import left_girl_th from './banner_left/left_girl_th.png';
import right_girl from './banner_right/right_girl.png';

import define_flower from './banner_left/define_flower.png';
import butterfly1 from './banner_left/Butterfly_1_small.png';
import butterfly2 from './banner_left/Butterfly_2_small.png';
import butterfly3 from './banner_left/Butterfly_3_small.png';

import define_girl from './banner_right/define_girl.png';

import girl_center_butterfly from './banner_left/left_girl_img.png';
import packshot_vm_ru from './banner_right/right-col-packshot.png';
import button_center from './banner_right/button-center.png';
import logo_center from './banner_right/Logo-Center.png';

export {
  left_girl_th,
  right_girl,
  stick1_left,
  flower1_left,
  lens1_left,
  lens1_grayzel_left,
  lens1_blue_left,
  stick2_left,
  flower2_left,
  hue1_left,
  hue2_left,
  girl_left,
  girl_my_left,
  flower3_big_left,
  lens2_big_left,
  lens2_big_grayzel_left,
  stick4_left,
  flower4_left,
  lens3_left,
  lens3_grayzel_left,
  lens3_blue_left,
  stick5_left,
  flower5_left,
  balloon1_right,
  balloon2_right,
  balloon3_right,
  balloon4_right,
  lens1_right,
  lens2_right,
  only_girl_right,
  thread_right,
  buttonON,
  buttonOFF,
  appsflyer_icon,
  download_icon,
  define_flower,
  butterfly1,
  butterfly2,
  butterfly3,
  define_girl,
  girl_center_butterfly,
  packshot_vm_ru,
  button_center,
  logo_center
};
